import React from 'react';
import { render } from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'clorian-frontend-components/dist/clorian-frontend-components.css';
import App from './App';
import Cookie from 'js-cookie';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'intl';
import 'intl/locale-data/jsonp/en.js';
import 'intl/locale-data/jsonp/es.js';
import 'intl/locale-data/jsonp/ca.js';
import 'intl/locale-data/jsonp/fr.js';

const rootElement = document.getElementById('root');

// Define user's language.
const locale = Cookie.get('locale') || 'en';

// Split locales with a region code
const languageWithoutRegionCode = locale.toLowerCase().split(/[_-]+/)[0];

// Our translated strings
let localeData;

// react-intl own translations
let intlCurrentData;


try {
	switch (languageWithoutRegionCode) {
		case 'es':
			require('moment/locale/es');
			intlCurrentData = require('react-intl/locale-data/es');
			localeData = require('./static/locales/es.json');
			break;
		case 'ca':
			require('moment/locale/ca');
			intlCurrentData = require('react-intl/locale-data/ca');
			localeData = require('./static/locales/ca.json');
			break;
		case 'fr':
			require('moment/locale/fr');
			intlCurrentData = require('react-intl/locale-data/fr');
			localeData = require('./static/locales/fr.json');
			break;
		case 'it':
			require('moment/locale/it');
			intlCurrentData = require('react-intl/locale-data/it');
			localeData = require('./static/locales/it.json');
			break;
		case 'pt':
			require('moment/locale/pt');
			intlCurrentData = require('react-intl/locale-data/pt');
			localeData = require('./static/locales/pt.json');
			break;
		default:
			// Language not supported, default english
			intlCurrentData = require('react-intl/locale-data/en');
			localeData = require('./static/locales/en.json');
			break;
	}
} catch (ex) {
	// Language not supported, default english
	intlCurrentData = require('react-intl/locale-data/en');
	localeData = require('./static/locales/en.json');
}


if (intlCurrentData) {
  addLocaleData(intlCurrentData);
}

// Try full locale, try locale without region code, fallback to 'en'
const messages = localeData || [];

function runApp(messages) {
  render(
    <IntlProvider locale={locale} messages={messages || []} defaultLocale="es">
      <App />
    </IntlProvider>,
    rootElement
  );
   serviceWorkerRegistration.unregister();
}

runApp(messages);
